<button mat-raised-button *ngIf="!client" color="primary" class="mt-3" (click)="changeClient()">Dodaj klienta</button>
<mat-card appearance="outlined" class="mb-3" *ngIf="client">
	<mat-card-title class="row d-flex justify-content-between">
		<p class="col fs-5" *ngIf="!client.firstName">{{ client?.shortName }} NIP: {{ client?.nip }}</p>
		<p class="col fs-5" *ngIf="client?.firstName">
			{{ client?.firstName }} {{ client?.lastName }} Telefon:
			{{ client.userContacts[0]?.phone }}
		</p>
		<button mat-icon-button [matMenuTriggerFor]="menu" class="fs-5">
			<i class="col text-end cursor-pointer fa fa-ellipsis-vertical"></i>
		</button>
		<mat-menu #menu>
			<button mat-menu-item (click)="changeClient()">
				<span> Zmień klienta</span>
			</button>
		</mat-menu>
	</mat-card-title>
	<mat-card-content *ngIf="!client.firstName">
		<a [routerLink]="'/organization/' + client?.id" target="_blank"> Przejdź do kontrahenta</a>
	</mat-card-content>
</mat-card>
